import React,{useState,useEffect} from 'react'
import clinicbookingService from '../../../../../services/clinicbooking.service'
import {useForm} from 'react-hook-form'
import {toast} from 'react-toastify'

function HourForm({hours,toogleEdit,saveUpdated}){
    const {register,handleSubmit,formState:{errors}} = useForm({
        defaultValues:hours
    })

    const onSubmit = (data) =>{
       saveUpdated(data)
    }
    return (<>
        <form onSubmit={handleSubmit(onSubmit)} className="row mb-2">
            
            <div className="col-2 mb-2">
                <input type="text"
                className='form-control'
                {...register("day")}
                />
            </div>
            <div className="col-2 mb-2">
                <select {...register("isOff")}className="form-select">
                    <option value="0">Working</option>
                    <option value="1">Off</option>
                </select>
                
            </div>
            <div className="col-2 mb-2">
                <input type="text"
                className='form-control'
                placeholder='Start Time'
                {...register("startTime")}
                />
            </div>
            <div className="col-2 mb-2">
                <input type="text"
                className='form-control'
                placeholder='End Time'
                {...register("endTime")}
                />
            </div>
            <div className="col-2 mb-2">
                <input type="text"
                className='form-control'
                placeholder='Lunch From'
                {...register("lunchFrom")}
                />
            </div>
            <div className="col-2 mb-2">
                <input type="text"
                placeholder='Lunch To'
                className='form-control'
                {...register("lunchTo")}
                />
            </div>
            <div className="col-1 mb-2">
               
            </div>
      
       
                <div className="d-flex justify-content-center mb-4">
                <button className="btn btn-sm btn-success me-4" type="submit"><i className="bi bi-floppy"></i> Save</button>
                <button className="btn btn-sm btn-warning" onClick={toogleEdit}><i className="bi bi-x-square"></i> Cancel</button>
           
                </div>
                </form>
                
    </>)
}
export default function DayHours({hours,handleUpdate}) {
    const [edit,setEdit] = useState(false)

 const toogleEdit = ()=>{
    setEdit(!edit)
 }

 const saveUpdated = (data)=>{
    handleUpdate(data)
    toogleEdit()
 }
  return (
    <>
        
            { edit? <HourForm hours={hours} toogleEdit={toogleEdit} saveUpdated={saveUpdated}/>:<>
           <div className="row">
            <div className="col-2 mb-2">{hours.day}</div>
            <div className="col-1 mb-2">{hours.isOff === 0 ? <span className="badge text-bg-success">Working</span>: <span className="badge text-bg-warning">Off</span>}</div>
            <div className="col-2 mb-2">{hours.startTime}</div>
            <div className="col-2 mb-2">{hours.endTime}</div>
            <div className="col-2 mb-2">{hours.lunchFrom}</div>
            <div className="col-2 mb-2">{hours.lunchTo}</div>
            <div className="col-1 mb-2">
                <button className="btn btn-secondary btn-sm" onClick={()=>setEdit(!edit)}><i className="bi bi-pencil-square"></i></button>    
             </div>
            </div>
            </>
            }
          

    </>
  )
}
